import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, AlertTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const NotificationManager = () => {
    const [open, setOpen] = useState(false);
    const [notification, setNotification] = useState(null);

    useEffect(() => {
        const handleNotification = (event) => {
            console.log('NotificationManager received event:', event.detail);
            setNotification(event.detail);
            setOpen(true);
        };

        window.addEventListener('foreground-notification', handleNotification);
        return () => window.removeEventListener('foreground-notification', handleNotification);
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
    };

    if (!notification) return null;

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{ mt: 7 }} // Offset from the app bar
        >
            <Alert
                onClose={handleClose}
                severity="info"
                variant="filled"
                sx={{ width: '100%', boxShadow: 6, borderRadius: 2 }}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                <AlertTitle>{notification.title || 'Notification'}</AlertTitle>
                {notification.body}
            </Alert>
        </Snackbar>
    );
};

export default NotificationManager;
